import React from "react";
import { PageHeader } from "../../components/Header";
import { Article } from "../../components/Containers";
import { ResumeEntry } from "../../components/Resume";
import { SkillsCard} from '../../components/Card'

import about from "../../content/sections/bio/about-hanna-de.json";
import resume from "../../content/sections/bio/cv-hanna-de.json";

export default () => {
  const name = `${about.name} ${about.surname}`;

  const edu = resume.education.map(entry => (
    <ResumeEntry
      date={entry.when}
      title={entry.what.title}
      subtitle={entry.what.subtitle}
    />
  ));

  const jobs = resume.experience.map(entry => (
    <ResumeEntry
      date={entry.when}
      title={entry.what.title}
      subtitle={entry.what.subtitle}
    />
  ));

  const cert = resume.certifications.map(entry => (
    <ResumeEntry
      date={entry.when}
      title={entry.what.title}
      subtitle={entry.what.subtitle}
    />
  ));

  return (
    <div>
      <PageHeader title={name} />
      <div className="container-fluid content-row">
        <div className="row mt">
          <div className="col-md-4"><SkillsCard skills={about.skills.area} title='Arbeitsfelder'/></div>
          <div className="col-md-4"><SkillsCard skills={about.skills.soft} title='Arbeitsweise'/></div>
          <div className="col-md-4"><SkillsCard skills={about.skills.perks} title='Arbeitsschwerpunkte'/></div>
        </div>
      </div>
      <div className="container-fluid content-row mb">
        <div className="col-md-8 col-md-offset-2">
        <h2>Ausbildung</h2>
        {edu}
        <h2 className="pt">Erfahrungen</h2>
        {jobs}
        <h2 className="pt">Zusätzliche Qualifikationen</h2>
        {cert}
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/about/hanna.js